import type { Palette } from '@mui/material/styles/createPalette';
import type {
  AdminRoutePath,
  MainRoutePath,
} from 'applications/GSP/shared/constants/router';
import type { ReactNode } from 'react';

export type { SidebarState as SidebarAnimatedComponentsState } from './store/types';

export type NavigationItemType = keyof Pick<Palette, 'primary' | 'secondary'>;

export enum SidebarTypes {
  DEFAULT = 'default',
  ADMIN = 'admin',
}

export interface NavigationItem {
  label: string;
  icon: ReactNode;
  to: MainRoutePath | AdminRoutePath;
  disabled?: boolean;
  sidebarType: SidebarTypes;
}

export enum NavigationItemStateKey {
  IsActive = 'isActive',
}

export interface NavigationItemState {
  [NavigationItemStateKey.IsActive]?: boolean;
}
